<template>
  <section>
    <router-view />

    <b-modal id="basic-error-alert"
            class="basic-modal no-header-modal hide-cancel-btn"
            v-bind:hide-header="true"
            v-bind:ok-title="$t('common.confirm')">
      <div v-html="$t('common.modal.basic_error_alert.message')"></div>
    </b-modal>
  </section>
</template>

<script>
export default {
  name: 'card-show',

  props: [
    'cardId',
  ],
};
</script>

